module.exports = __webpack_public_path__ + "media/img/corporate/hero-mobile-7f35f41d47d189cb4ff3d8e7547d2d74.png";